import clsx from "clsx";
import zipFolder from "../../assets/images/zipIcon.svg";
import {
  lienColumnsType,
  syncDetailsType,
  syncSummaryType,
} from "../../Types/lienProcessingTypes";
import { formatNumber } from "../../utils/numberFormatterUtil";
import styles from "./LienProcess.module.scss";
import { message } from "antd";

export const getLastSyncedInfo = (syncDetails: syncDetailsType) => {
  return syncDetails?.date
    ? `Last synced on ${syncDetails?.date} at ${syncDetails?.time}`
    : "";
};

export const lienProcessConsts = {
  CONFIRM_SYNC_TITLE: "Sync QuickBook",
  CONFIRM_SYNC_TEXT: "Are you sure you want to sync the data from QuickBooks?",
  CONFIRM_SYNC_WIDTH: "50rem",
  SYNC_RESULT_WIDTH: "60rem",
  SYNC_RESULT_TITLE: "Summary",
  EXPORT_NON_SYNCED: "Export non synced Records",
  ROLE_DETAILS_KEY: "userRoleInfo",
  PROFILE_DETAILS_KEY: "userProfile",
  EDIT_ROLE: "Edit",
  EMPTY_TABLE_MSG: "No Records Found",
  TOP_20_WARNING: "Only top 20 records will be selected",
  MAX_SELECTION: 20,
};

export const getPageKeys = (rows) => rows.map(r => r.key);

export const STATIC_ALERT =
  "Data for Previous stage, Next stage, and Filing date will be shown in upcoming stages";

export const lienColumns = ({
  handleDownloadClick,
  editAccess,
}: lienColumnsType) => [
  {
    title: "Customer Name",
    dataIndex: "customerName",
    key: "customerName",
    width: "8rem",
    render: (text) => <>{text}</>,
  },
  {
    title: "Job Name",
    dataIndex: "jobName",
    key: "jobName",
    width: "10rem",
    render: (text) => <>{text}</>,
  },
  {
    title: "Month",
    dataIndex: "month",
    key: "month",
    width: "5rem",
    render: (text) => <>{text}</>,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    width: "5rem",
    render: (value) => <>$ {formatNumber(Number(value).toFixed(2))}</>,
  },
  {
    title: "Open Balance",
    dataIndex: "openBalance",
    key: "openBalance",
    width: "5rem",
    render: (value) => <>$ {formatNumber(Number(value).toFixed(2))}</>,
  },
  {
    title: "Previous Stage",
    dataIndex: "previousStage",
    key: "previousStage",
    width: "6rem",
    align: "center",
    render: () => <>{"-"}</>,
  },
  {
    title: "Next Stage",
    dataIndex: "nextStage",
    key: "nextStage",
    width: "6rem",
    align: "center",
    render: () => <>{"-"}</>,
  },
  {
    title: "Filing Date",
    dataIndex: "filingDate",
    key: "filingDate",
    width: "6rem",
    align: "center",
    render: () => <>{"-"}</>,
  },
  {
    title: "Forms",
    dataIndex: "id",
    key: "id",
    width: "3rem",
    align: "center",
    render: (_, record) => (
      <div
        onClick={() => {
          if (editAccess) {
            if(record?.documentsGenerated)
              handleDownloadClick(record?.id);
          } else message.error("Access required to download");
        }}
        className={clsx({ 
          [styles.downloadOnClickOption]: editAccess,
          [styles.grayScale]: !!!record?.documentsGenerated,
        })}
      >
        <img src={zipFolder} alt={"Click to download"} />
      </div>
    ),
  },
];

export const syncSummaryValues = (syncSummary: syncSummaryType) => {
  return [
    {
      title: "Received from QuickBooks",
      value: syncSummary?.totalInvoices,
      label: "Invoices",
    },
    {
      title: "Updated in our system",
      value: syncSummary?.syncedCount,
      label: "Invoices",
    },
    {
      title: "Non-synced records",
      value: syncSummary?.unsyncedCount,
      label: "Invoices",
    },
  ];
};

export const warningNotificationStyle = {
  backgroundColor: "#FFFAEE",
  borderRadius: "0.875rem",
  marginRight: "-1.875rem",
};
